var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _polygon2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawContentCreatorRePt5B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 766.06693,
    height: 517,
    viewBox: "0 0 766.06693 517",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M978.03346,618.5h-379a5.00573,5.00573,0,0,1-5-5v-417a5.00573,5.00573,0,0,1,5-5h379a5.00573,5.00573,0,0,1,5,5v417A5.00573,5.00573,0,0,1,978.03346,618.5Zm-379-425a3.00328,3.00328,0,0,0-3,3v417a3.00328,3.00328,0,0,0,3,3h379a3.00328,3.00328,0,0,0,3-3v-417a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M762.53346,350.5h-94a5.00573,5.00573,0,0,1-5-5v-94a5.00573,5.00573,0,0,1,5-5h94a5.00573,5.00573,0,0,1,5,5v94A5.00573,5.00573,0,0,1,762.53346,350.5Zm-94-102a3.00328,3.00328,0,0,0-3,3v94a3.00328,3.00328,0,0,0,3,3h94a3.00328,3.00328,0,0,0,3-3v-94a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M735.53346,362h-94a4.50508,4.50508,0,0,1-4.5-4.5v-94a4.50508,4.50508,0,0,1,4.5-4.5h94a4.50507,4.50507,0,0,1,4.5,4.5v94A4.50507,4.50507,0,0,1,735.53346,362Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M935.53346,408h-294a4.5,4.5,0,0,1,0-9h294a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M864.53346,439h-223a4.5,4.5,0,0,1,0-9h223a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M934.53346,294h-130a4.5,4.5,0,0,1,0-9h130a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M902.08986,325h-97.5564a4.5,4.5,0,0,1,0-9h97.5564a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M935.53346,470h-294a4.5,4.5,0,0,1,0-9h294a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M864.53346,501h-223a4.5,4.5,0,0,1,0-9h223a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M935.53346,532h-294a4.5,4.5,0,0,1,0-9h294a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M935.53346,563h-294a4.5,4.5,0,0,1,0-9h294a4.5,4.5,0,1,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M698.4626,579.811h-215a5.00573,5.00573,0,0,1-5-5v-133a5.00573,5.00573,0,0,1,5-5h215a5.00573,5.00573,0,0,1,5,5v133A5.00573,5.00573,0,0,1,698.4626,579.811Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M698.4626,579.811h-215a5.00573,5.00573,0,0,1-5-5v-133a5.00573,5.00573,0,0,1,5-5h215a5.00573,5.00573,0,0,1,5,5v133A5.00573,5.00573,0,0,1,698.4626,579.811Zm-215-141a3.00328,3.00328,0,0,0-3,3v133a3.00328,3.00328,0,0,0,3,3h215a3.00328,3.00328,0,0,0,3-3v-133a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M655.9626,497.311h-130a4.5,4.5,0,0,1,0-9h130a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M655.9626,528.311h-130a4.5,4.5,0,0,1,0-9h130a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230.335 504.891 242.595 504.891 248.427 457.603 230.333 457.604 230.335 504.891",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.17433,692.38852l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00146Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.876 499.584 146.998 501.416 159.834 455.532 143.943 452.828 134.876 499.584",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M349.3485,686.659l23.8729,3.60829.001.00015a15.3873,15.3873,0,0,1,12.91352,17.51344l-.07474.49438-39.08679-5.90794Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M389.64274,462.04316l13.61234,3.56656-.90556,22.06943-.11221,40.18164a8.05269,8.05269,0,1,1-10.65739,1.33914l-4.183-40.32883Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387.27321,436.76465a11.112,11.112,0,0,1,6.86914-9.88184,10.38874,10.38874,0,0,1,11.24536,1.8086,9.90512,9.90512,0,0,1,3.30176,7.66015c.03589,12.92871-2.88281,31.77344-2.91235,31.96192l-.04663.2998-19.89673,6.7002Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M422.84952,473.46457l30.43253-7.87755,14.06747,47.37755.5,176.5-23.27183-.14567-9.72817-142.85433-62,132-25-3,54.5-141.5s-3-25,6.5-37.5l-2-13Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M402.32936,485.252a4.66294,4.66294,0,0,1-.99487-3.751l-13.88135-41.64453a10.59476,10.59476,0,0,1,2.92212-11.18262l6.02612-5.47754,4.08374-16.335,23.47144,5.7373-1.93384,7.73535,10.62256-1.93066,22.374,49.832-46.76757,18.69336-2.30323.03613A4.66233,4.66233,0,0,1,402.32936,485.252Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M434.90714,450.09054l13.41089-4.262,11.03149,19.136L480.73307,498.984a8.0527,8.0527,0,1,1-8.29126,6.82849l-25.09229-31.8479Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.39235,429.99219a11.11077,11.11077,0,0,1,.52344-12.02246,10.39434,10.39434,0,0,1,10.4707-4.48243,9.90544,9.90544,0,0,1,6.885,4.709c6.94092,10.90723,14.54736,28.39453,14.62329,28.56934l.12061.27832L438.78127,463.3418Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200.88438,
    cy: 193.67287,
    r: 18.64889,
    fill: "#a0616a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.92773,
    cy: 167.84291,
    r: 17.96364,
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.39969,374.21795a17.96458,17.96458,0,0,0,27.74061-9.43241,17.96463,17.96463,0,1,1-35.04222-7.36674A17.958,17.958,0,0,0,369.39969,374.21795Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M440.29212,374.23792c-3.136-5.61432-4.33594-7.95958-8.37942-11.37357-3.57566-3.01934-7.97385-3.906-11.52134-1.04515A21.24492,21.24492,0,1,0,433.21,381.32007a21.42139,21.42139,0,0,0-.14474-2.4022C436.14885,378.48481,437.2085,374.671,440.29212,374.23792Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M598.96654,708.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-216.96654 -191.5)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawContentCreatorRePt5B);
export default __webpack_public_path__ + "static/media/undraw_content_creator_re_pt5b.6c8d5feaa5949009d3b41e875fbd7565.svg";
export { ForwardRef as ReactComponent };